import * as Yup from 'yup';
import { nameSchema, emailSchema, phoneSchema } from './fieldSchemas';

export const PersonSchema = Yup.object().shape({
  name: nameSchema({
    required: true,
    requiredMessage: 'İsim zorunludur',
  }),
  hospitalId: Yup.number().required('Hastane seçimi zorunludur').nullable(),
  phoneNumber: phoneSchema({
    required: true,
    requiredMessage: 'Telefon numarası zorunludur',
  }),
  email: emailSchema({
    required: false,
  }),
});
